import React, { useContext, useEffect, useState } from "react";
import Moment from "react-moment";
import { UserContext } from "./UserProvider";
import {
  HAS_EVENT_TIMEZONE_SUPPORT,
  APP_BRAND_NAME,
  BRAND,
} from "../utils/consts";

const ReceptionWelcome = ({ meetingDetails, companyProfile, meetingOpen }) => {
  const { fullName } = useContext(UserContext);

  const [meetingOpenCombined, setMeetingOpenCombined] = useState(false);

  useEffect(() => {
    if (meetingOpen !== undefined) {
      setMeetingOpenCombined(meetingOpen);
    } else if (
      meetingDetails !== null &&
      meetingDetails.VirtualMeeting &&
      meetingDetails.VirtualMeeting.CompanyMeeting
    ) {
      setMeetingOpenCombined(
        meetingDetails.VirtualMeeting.CompanyMeeting.MeetingOpen
      );
    }
  }, [meetingDetails, meetingOpen]);

  return (
    <div style={{ padding: "3rem" }}>
      {meetingDetails && companyProfile && (
        <div className="row">
          <div style={{ paddingRight: "1rem" }}>
            <img
              src="/img/no-reception-person.png"
              className="rounded-lg bg-light"
              width="100"
              height="100"
              alt={meetingDetails.EventProfile.Name}
            />
          </div>
          <div className="col">
            <div className="card welcome-card">
              <div className="card-body">
                <h6 class="welcome-card-text">
                  Hi {fullName}, and welcome to the {companyProfile.CompanyName}{" "}
                  Meeting Suite. Your meeting with{" "}
                  {meetingDetails.EventProfile.Name} is set for{" "}
                  <Moment format="h:mma">
                    {HAS_EVENT_TIMEZONE_SUPPORT
                      ? meetingDetails.EventStartTimeWithTz
                      : meetingDetails.EventStartTime}
                  </Moment>
                  &nbsp;
                  <Moment format="MMMM DD">
                    {HAS_EVENT_TIMEZONE_SUPPORT
                      ? meetingDetails.EventStartTimeWithTz
                      : meetingDetails.EventStartTime}
                  </Moment>
                  {meetingOpenCombined && (
                    <span> and is already in progress</span>
                  )}
                  .
                </h6>
                <h6 class="welcome-card-text">
                  {meetingOpenCombined ? (
                    <>
                      Please press the JOIN MEETING button and you can enter the
                      room.
                    </>
                  ) : (
                    <>
                      When {meetingDetails.EventProfile.firstname} is ready your{" "}
                      <b>JOIN MEETING</b> button will turn{" "}
                      <span className="join-button-color">
                        {APP_BRAND_NAME === BRAND.BANFF ? "Green" : "blue"}
                      </span>{" "}
                      and you can enter the meeting.
                    </>
                  )}
                </h6>
                {!meetingOpenCombined && (
                  <h6 class="welcome-card-text">
                    You may also let {meetingDetails.EventProfile.firstname}{" "}
                    know you are here by using <b>NOTIFY</b> button.
                  </h6>
                )}
                <br />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReceptionWelcome;
